export const DEFAULT_SEARCH_SETTINGS = {
  searchFields: [
    {
      name: 'title',
      status: true,
      searchWeight: 'high'
    },
    {
      name: 'barcode',
      status: true,
      searchWeight: 'medium'
    },
    {
      name: 'productCategory',
      status: true,
      searchWeight: 'medium'
    },
    {
      name: 'productOptions',
      status: true,
      searchWeight: 'medium'
    },
    {
      name: 'productType',
      status: true,
      searchWeight: 'medium'
    },
    {
      name: 'sku',
      status: true,
      searchWeight: 'medium'
    },
    {
      name: 'tag',
      status: true,
      searchWeight: 'medium'
    },
    {
      name: 'vendor',
      status: true,
      searchWeight: 'medium'
    },
    // {
    //   name: 'collection',
    //   status: true
    // },
    {
      name: 'description',
      status: false
    },
    {
      name: 'metafields',
      status: false
    }
  ],
  inCollectionSearch: {
    enableCollectionSearch: false,
    collectionSearchLabel: 'Search for products in this collection'
  },
  minimumMustMatch: {
    twoWords: 100,
    threeWordsAndAbove: 85
  },
  fuzzySearch: ['true']
};

export const FIELDS_NOT_SUPPORT_IN_V1 = ['productCategory', 'metafields'];

export const SEARCH_VERSION = {
  one: ['1.0'],
  two: ['2.0']
};
export const SEARCH_FIELDS_WEIGHT = [
  {
    value: 'high',
    label: 'AdminHTML.SearchSettings.SearchFields.searchWeightHigh'
  },
  {
    value: 'medium',
    label: 'AdminHTML.SearchSettings.SearchFields.searchWeightMedium'
  },
  {
    value: 'low',
    label: 'AdminHTML.SearchSettings.SearchFields.searchWeightLow'
  },
  {
    value: 'non-searchable',
    label: 'AdminHTML.SearchSettings.SearchFields.searchWeightNonSearchable'
  }
];
export const SEARCH_FIELDS_TITLE = {
  title: 'AdminHTML.SearchSettings.SearchFields.searchFields_Title',
  productType: 'AdminHTML.SearchSettings.SearchFields.searchFields_ProductType',
  productCategory: 'AdminHTML.SearchSettings.SearchFields.searchFields_ProductCategory',
  vendor: 'AdminHTML.SearchSettings.SearchFields.searchFields_Vendor',
  tag: 'AdminHTML.SearchSettings.SearchFields.searchFields_Tag',
  productOptions: 'AdminHTML.SearchSettings.SearchFields.searchFields_ProductOptions',
  sku: 'AdminHTML.SearchSettings.SearchFields.searchFields_Sku',
  variantTitle: 'AdminHTML.SearchSettings.SearchFields.searchFields_VariantTitle',
  barcode: 'AdminHTML.SearchSettings.SearchFields.searchFields_Barcode',
  collection: 'AdminHTML.SearchSettings.SearchFields.searchFields_Collection',
  description: 'AdminHTML.SearchSettings.SearchFields.searchFields_Description',
  metafields: 'AdminHTML.SearchSettings.SearchFields.searchFields_Metafields'
};

export const FUZZY_SEARCH_OPTIONS = [
  {
    value: 'false',
    label: 'AdminHTML.SearchSettings.Advanced.fuzzySearchOptionOff'
  },
  {
    value: '1',
    label: 'AdminHTML.SearchSettings.Advanced.fuzzySearchOptionLow'
  },
  {
    value: 'true',
    label: 'AdminHTML.SearchSettings.Advanced.fuzzySearchOptionHigh'
  }
];
